












































































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import Colorable from '@/mixins/colorable';

export default mixins(Proxyable, Colorable).extend({
  props: {
    itemRequired: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showNote: false
  })
});
